import React from "react";
import { Pie } from "react-chartjs-2";

const ChartPieAge = ({ ageStatistics }) => {
    const colors = [
        "#FF6384",  // Pink for 18-25
        "#36A2EB",  // Blue for 25-35
        "#FFCE56",  // Yellow for 35-45
        "#4BC0C0",  // Teal for 45+
        "#9966FF"   // Purple for Under 18
    ];

    const data = {
        datasets: [
            {
                data: ageStatistics?.summary?.data || [],
                borderWidth: 2,
                backgroundColor: colors.slice(0, ageStatistics?.chartData?.length || 0),
                hoverBackgroundColor: colors.slice(0, ageStatistics?.chartData?.length || 0).map(color => color + 'DD'),
            },
        ],
        labels: ageStatistics?.summary?.labels || [],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                fontSize: 14,
                padding: 15
            }
        },
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                    const dataset = data.datasets[tooltipItem.datasetIndex];
                    const currentValue = dataset.data[tooltipItem.index];
                    const label = data.labels[tooltipItem.index];
                    const total = ageStatistics?.total || 0;
                    const percentage = total > 0 ? ((currentValue / total) * 100).toFixed(2) : 0;
                    return `${label}: ${currentValue} (${percentage}%)`;
                }
            }
        }
    };

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <Pie
                data={data}
                options={options}
            />
        </div>
    );
};

export default ChartPieAge;